import React from 'react';
import PropTypes from 'prop-types';
import './CreditSummary.scss';

const getFirstMonthsCostMessage = (price, credit) => {
  const firstMonthsCost = price - credit;
  if (firstMonthsCost > 0) {
    return ` – your plan will only cost $${firstMonthsCost} for the first month.`;
  }
  return '.';
};

const CreditSummary = props => (
  <div className="credit-summary">
    ${props.credit} joining credit{getFirstMonthsCostMessage(props.price, props.credit)}
  </div>
);

CreditSummary.propTypes = {
  credit: PropTypes.number,
  price: PropTypes.number
};

export default CreditSummary;



/** WEBPACK FOOTER **
 ** ./src/components/creditsummary/CreditSummary.js
 **/